export default {
  title: 'Facturi comenzi',
  list: {
    empty_list: {
      title: 'Nicio factură de comandă încă.',
    },
    fields: {
      id: 'Id',
      total: 'Total',
      date: 'Dată',
    },
  },
  export_modal: {
    title: 'Filtrare',
    start_date: {
      title: 'Dată început',
      placeholder: 'dată',
    },
    end_date: {
      title: 'Dată sfârșit',
      placeholder: 'dată',
    },
    button: {
      title1: 'Aplică',
      title2: 'Închide',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
